import { apiClient } from './client'
import type {
  CreateGlobalCatalogMaterialRequest,
  CreateGlobalCatalogToolRequest,
  GlobalCatalogConflict,
  GlobalCatalogMaterial,
  GlobalCatalogPage,
  GlobalCatalogTool,
} from './types'

export const searchGlobalMaterials = async (
  query: string,
  page: number = 0,
  size: number = 20
): Promise<GlobalCatalogPage<GlobalCatalogMaterial>> => {
  const response = await apiClient.get<GlobalCatalogPage<GlobalCatalogMaterial>>(
    '/api/v1/global-catalog/materials',
    { params: { q: query || undefined, page, size } }
  )
  return response.data
}

export const searchGlobalTools = async (
  query: string,
  page: number = 0,
  size: number = 20
): Promise<GlobalCatalogPage<GlobalCatalogTool>> => {
  const response = await apiClient.get<GlobalCatalogPage<GlobalCatalogTool>>(
    '/api/v1/global-catalog/tools',
    { params: { q: query || undefined, page, size } }
  )
  return response.data
}

/**
 * Phase 15 — global material create. The 409 case is part of the contract: callers should
 * .catch the AxiosError and unwrap `error.response.data` as a {@link GlobalCatalogConflict}
 * to render the "use existing" affordance.
 */
export const createGlobalMaterial = async (
  request: CreateGlobalCatalogMaterialRequest
): Promise<GlobalCatalogMaterial> => {
  const response = await apiClient.post<GlobalCatalogMaterial>(
    '/api/v1/global-catalog/materials',
    request
  )
  return response.data
}

export const createGlobalTool = async (
  request: CreateGlobalCatalogToolRequest
): Promise<GlobalCatalogTool> => {
  const response = await apiClient.post<GlobalCatalogTool>('/api/v1/global-catalog/tools', request)
  return response.data
}

/** Type guard for the 409 conflict body. */
export const isGlobalCatalogConflict = (body: unknown): body is GlobalCatalogConflict => {
  if (typeof body !== 'object' || body === null) return false
  const b = body as Record<string, unknown>
  return typeof b.existingId === 'string' && typeof b.detail === 'string'
}
